/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid2,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { showGroups } from 'js/actions/groupActions';
import { showMeters } from 'js/actions/meterActions';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { getReportTotalsByDate } from 'js/actions/reportsActions';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS, es } from 'date-fns/locale';

const useStyles = makeStyles(styles);

export default function TotalsHourly() {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { handleSubmit } = useForm();
  const corporatives = useSelector((state) => state.corporatives.corporatives);
  const { user } = useSelector((state) => state.user);
  const { meters } = useSelector((state) => state.meters);
  const corpUser = user.corporative;
  let groups = useSelector((state) => state.groups.groups);
  const localeNav = useSelector((state) => state.prefs.locale);

  const [corporative, setCorporative] = useState();
  const [meter, setMeter] = useState();
  const [group, setGroup] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [includePrice, setIncludePrice] = useState(false);
  const [blocking, setBlocking] = useState(false);

  function useBlocking() {
    setBlocking(false);
  }

  const locale = localeNav === 'es-MX' ? es : enUS;

  const formatDateToYYYYMMDD = (date) => {
    if (!date) return ''; // Manejo de casos nulos o indefinidos
    const d = new Date(date);
    return d.toISOString().split('T')[0].replace(/-/g, '');
  };

  const getSelector = (corp) => {
    if (corp === 1) {
      return (
        <FormControl variant="outlined" className={classes.textField}>
          <InputLabel id="demo-simple-select-outlined-label">
            {intl.formatMessage({ id: 'app.reports.hourReports.corporateLbl' })}
          </InputLabel>
          <Select
            id="demo-simple-select-outlined"
            labelId="demo-simple-select-outlined-label"
            onChange={handleCorporative}
            value={corporative}
            input={
              <OutlinedInput
                label={intl.formatMessage({
                  id: 'app.reports.hourReports.corporateLbl',
                })}
              />
            }
          >
            {shortCorporatives()?.map((el) => (
              <MenuItem value={el.id} key={el.id}>
                {el.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    } else {
      return null;
    }
  };

  const getMeters = (corporativeId) => {
    dispatch(showMeters(corporativeId));
  };

  const onSubmit = () => {
    setBlocking(true);
    dispatch(
      getReportTotalsByDate(
        meter,
        group,
        formatDateToYYYYMMDD(startDate),
        formatDateToYYYYMMDD(endDate),
        includePrice ? 1 : 0,
        useBlocking
      )
    );
  };

  useEffect(() => corpUser && getMeters(corpUser.id), []);

  const getGroup = (meterId) => {
    dispatch(showGroups(meterId));
  };

  const handleCorporative = (corporative) => {
    setCorporative(corporative.target.value);
    setGroup([]);
    getMeters(corporative.target.value);
  };

  const handleMeter = (meter) => {
    setMeter(meter.target.value);
    setGroup([]);
    getGroup(meter.target.value);
  };

  const handleGroup = (group) => {
    const { value } = group.target;
    setGroup(value); // value será un array de ids seleccionados

    // Si selecciona "TODAS", se seleccionan todos los grupos
    // Si no, se selecciona el grupo seleccionado
    if (value.includes('TODAS')) {
      setGroup(['TODAS']);
    }

    // Si esta seleccionado "TODAS" y seleccionan otro grupo
    // se deselecciona "TODAS" y selecciona el grupo seleccionado
    if (group.target.value.includes('TODAS') && group.target.value.length > 1) {
      setGroup(group.target.value.filter((el) => el !== 'TODAS'));
    }
  };

  const handleStartDate = (event) => {
    setStartDate(event);
  };

  const handleEndDate = (event) => {
    setEndDate(event);
  };

  const handleCheckBox = (event) => {
    setIncludePrice(event.target.checked);
  };

  const shortCorporatives = () => {
    const shortArray = [...corporatives];
    return shortArray.sort((a, b) =>
      a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        bgcolor: 'white',
        p: 4,
        borderRadius: 1,
        boxShadow: 1,
      }}
      width="100%"
    >
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid2 container={true} spacing={2}>
          <Grid2
            size={{ lg: 3, md: 6, xs: 6 }}
            sx={{ display: user.adser ? 'block' : 'none' }}
          >
            {getSelector(user.adser)}
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.hourReports.meterLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                labelId="demo-simple-select-outlined-label"
                name="meter"
                onChange={handleMeter}
                value={meter}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.hourReports.meterLbl',
                    })}
                  />
                }
              >
                {meters?.map((el) => (
                  <MenuItem value={el.id} key={el.id}>
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.hourReports.groupLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                labelId="demo-simple-select-outlined-label"
                multiple
                name="group"
                onChange={handleGroup}
                value={group}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.hourReports.groupLbl',
                    })}
                  />
                }
                renderValue={(selected) => {
                  if (!selected.length) return 'Seleccione grupos'; // Texto por defecto si no hay selección
                  return selected
                    .map((value) => {
                      if (value === 'TODAS') return 'TODAS';
                      // Si el valor es 'TODAS', no buscamos en groups
                      // Buscamos el nombre del grupo en groups
                      // y lo devolvemos
                      // Si no se encuentra, devolvemos un string vacío
                      // para evitar errores
                      // al intentar acceder a la propiedad name
                      // de un objeto undefined
                      // o null
                      const groupName = groups.find(
                        (el) => el.id === value
                      )?.name;
                      return groupName ? groupName : '';
                    })
                    .join(', ');
                }}
              >
                <MenuItem
                  value="TODAS"
                  onClick={() => handleGroup({ target: { value: 'TODAS' } })}
                >
                  <Checkbox checked={group.indexOf('TODAS') > -1} />
                  TODAS
                </MenuItem>
                {groups?.map((el) => (
                  <MenuItem value={el.id} key={el.id}>
                    <Checkbox checked={group.indexOf(el.id) > -1} />
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={locale}
          >
            <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
              <DatePicker
                className={classes.textField}
                id="date"
                label="Fecha Inicial"
                selected={startDate} // Usa el estado como valor
                onChange={handleStartDate} // Maneja cambios en la fecha
                dateFormat="yyyy-MM-dd" // Formato deseado
                maxDate={new Date()} // Restringe fechas futuras
              />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
              <DatePicker
                className={classes.textField}
                id="date"
                label="Fecha Final"
                minDate={startDate}
                selected={endDate} // Usa el estado como valor
                onChange={handleEndDate} // Maneja cambios en la fecha
                dateFormat="yyyy-MM-dd" // Formato deseado
                maxDate={new Date()} // Restringe fechas futuras
              />
            </Grid2>
          </LocalizationProvider>
          <Grid2 size={{ lg: 3, md: 12, xs: 12 }} sx={{ display: 'flex' }}>
            <FormControlLabel
              className={classes.textField}
              control={
                <Checkbox
                  selected={includePrice}
                  color="secondary"
                  onChange={handleCheckBox}
                />
              }
              label={intl.formatMessage({
                id: 'app.reports.totReports.includePrice',
              })}
            />
          </Grid2>
          <Button
            className={classes.signUpButton}
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            loadingPosition="start"
            loading={blocking}
          >
            {blocking
              ? 'Cargando...'
              : intl.formatMessage({
                  id: 'app.reports.hourReports.uploadBtn',
                })}
          </Button>
        </Grid2>
      </form>
    </Box>
  );
}
